
import FormFieldProps from './mixins/FormControlProps';
import { ControlFactoryProperty } from './controls/factories/enums';
import { FormFieldProperty } from './enums';
import ControlFactory from './controls/factories/control-factory';
import FormErrorMessage from './form-error-message';
import { ControlEventType, ControlPropertyType } from './controls/enums';
import { StyleColorSchemeType } from '../../styles/enums';

export default {
  name: 'FormField',
  components: {
    ControlFactory,
    FormErrorMessage,
  },
  mixins: [FormFieldProps],
  data() {
    return {
      ControlEventType,
    };
  },
  computed: {
    controlFactoryProps() {
      return {
        [ControlFactoryProperty.ControlProps]: {
          ...this[FormFieldProperty.ControlProps],
          [ControlPropertyType.Label]: this.label,
          [ControlPropertyType.Value]: this.controlValue,
          [ControlPropertyType.ColorScheme]: this.controlColorSchema,
          [ControlPropertyType.Disabled]: this.controlIsDisabled,
        },
        [ControlFactoryProperty.Type]: this[FormFieldProperty.Type],
      };
    },
    label() {
      const isRequired = this[FormFieldProperty.FormControl]?.isRequired;
      const label = this[FormFieldProperty.ControlProps][ControlPropertyType.Label];

      return isRequired && label
        ? `${label} *`
        : label;
    },
    controlValue() {
      return this[FormFieldProperty.FormControl]?.value;
    },
    controlError() {
      return this[FormFieldProperty.FormControl]?.error;
    },
    controlIsValid() {
      return this[FormFieldProperty.FormControl]?.isValid;
    },
    controlIsDisabled() {
      return this[FormFieldProperty.FormControl]?.isDisabled
        || this[FormFieldProperty.ControlProps][ControlPropertyType.Disabled];
    },
    controlColorSchema() {
      return this.controlIsValid
        ? this[FormFieldProperty.ControlProps][ControlPropertyType.ColorScheme]
        : StyleColorSchemeType.Danger;
    },
  },
  methods: {
    handleEvent(eventType, callback) {
      callback?.();

      this.$nextTick(() => {
        const control = this[FormFieldProperty.FormControl];
        const isValidationStrategyEvent = eventType === control.validationStrategy
          || control.validationStrategy?.includes(eventType);

        if (isValidationStrategyEvent) {
          control.validate();
        }
      });
    },
    handleBlur() {
      this.handleEvent(ControlEventType.Blur, () => {
        this.$emit(ControlEventType.Blur);
      });
    },
    handleFocus() {
      this.handleEvent(ControlEventType.Focus, () => {
        this.$emit(ControlEventType.Focus);
      });
    },
    handleChange(value) {
      this.handleEvent(ControlEventType.Change, () => {
        this[FormFieldProperty.FormControl].setValue(value);
        this.$emit(ControlEventType.Change, value);
      });
    },
  },
};
